import Axios from 'axios'
import store from '../store'

const room = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getRooms () {
    return Axios.get('api/internal/clients/' + this.getClientId() + '/rooms')
  },
  createRoom (locationId, room) {
    return Axios.post('api/internal/clients/' + this.getClientId() + '/locations/' + locationId + '/rooms', room)
  },
  createCombinedRoom (locationId, room) {
    return Axios.post('api/internal/clients/' + this.getClientId() + '/locations/' + locationId + '/combinedRooms', room)
  },
  editRoom (locationId, room) {
    return Axios.put('api/internal/clients/' + this.getClientId() + '/locations/' + locationId + '/rooms/' + room.id, room)
  },
  editCombinedRoom (locationId, room) {
    return Axios.put('api/internal/clients/' + this.getClientId() + '/locations/' + locationId + '/combinedRooms/' + room.id, room)
  },
  deleteRoom (locationId, roomId) {
    return Axios.delete('api/internal/clients/' + this.getClientId() + '/locations/' + locationId + '/rooms/' + roomId)
  },
  sendRoomImage (roomId, image) {
    var file = new FormData()
    file.append('imageFile', image)
    return Axios.put('api/internal/clients/' + this.getClientId() + '/rooms/' + roomId + '/image', file)
  },
  saveBehavior (locationId, roomId, behavior) {
    return Axios.put('api/internal/clients/' + this.getClientId() + '/locations/' + locationId + '/rooms/' + roomId + '/behavior', behavior)
  },
  saveCombinedRoomBehavior (locationId, roomId, behavior) {
    return Axios.put('api/internal/clients/' + this.getClientId() + '/locations/' + locationId + '/combinedRooms/' + roomId + '/behavior', behavior)
  },
  getBehavior (roomId) {
    return Axios.get('api/internal/rooms/' + roomId + '/behavior')
  },
  getCombinedRoomBehavior (roomId) {
    return Axios.get('api/internal/combinedRooms/' + roomId + '/behavior')
  },
  toggleActive (locationId, roomId, active) {
    if (active) {
      return Axios.put('api/internal/clients/' + this.getClientId() + '/locations/' + locationId + '/rooms/' + roomId + '/deactivate')
    }
    return Axios.put('api/internal/clients/' + this.getClientId() + '/locations/' + locationId + '/rooms/' + roomId + '/activate')
  },
  checkCalendarConnection (roomEmail) {
    return Axios.get('api/internal/clients/' + this.getClientId() + '/rooms/calendar/' + roomEmail)
  },
  getImage (roomId) {
    return Axios.get('api/internal/clients/' + this.getClientId() + '/rooms/' + roomId + '/image', { responseType: 'arraybuffer' })
  },
  getRoomDevices(roomId) {
    return Axios.get(`/api/internal/clients/${this.getClientId()}/rooms/${roomId}/devices`)
  },
  saveRoomDevices (roomId, devices, blockAccessUponPriorBooking) {
    const body = { blockAccessUponPriorBooking, devices }
    return Axios.put(`/api/internal/clients/${this.getClientId()}/rooms/${roomId}/devices`, body)
  }
}

export default room
